import React, { useEffect, useRef, useState } from 'react'
import { Card } from 'antd'
import dayjs from 'dayjs'
import {
  dateFormatYearMonthDay,
  downLoadFileBlob,
  formatEndTime,
  formatMessageNew,
  formatStartTime
} from '@/utils/common'
import {
  getTunnelValidationResultData,
  getTunnelValidationResultDownload
} from '@/services/rfid/reports/tunnelScanValidationResult'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import { CARTON_PE, REWORK_CHECK_RESULT_STATUS } from '@/utils/types'
import ActionBar from '../../../components/table/ActionBar'
import { modalError } from '../../../utils/modalUtils'
import { initValueAndLabel, paginationInit, uniqueFun } from '../../../utils/common'
import { useSelector } from 'react-redux'
import { getOutboundScanDropList } from '../../../services/rfid/reports/rfidTunnelScanAccuracyReport'

// 固定为 IB，页面不再提供 Business Type 查询条件
const IB_BUSINESS_TYPE = '1'
const startMonth = dayjs().subtract(1, 'day')
const endMonth = dayjs().subtract(1, 'day')
const UNKNOWN_SKU_CODE = 'UNKNOWN_SKU'
export const CHECK_LIST = [
  { value: '1', label: 'Y' },
  { value: '0', label: 'N' }
]
const TunnelScanValidationResult = () => {
  const [summaryTableList, setSummaryTableList] = useState([])
  const [detailTableList, setDetailTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const mounting = useRef(false)
  // 列过滤 state（多选下拉，值为 Y/N）
  const [nfcSkuFilter, setNfcSkuFilter] = useState([])
  const [specialSkuFilter, setSpecialSkuFilter] = useState([])
  const { rows, totals } = buildSummary(summaryTableList)
  const bingResultConfig = {
    // 1: 正确，2: EPC多，3: EPC少，4: UPC不匹配，5: 异常，6: 人工确认，7: 新箱号
    1: {
      key: 'languageObj.tunnelScanValidationResult.accurate'
    },
    2: {
      key: 'languageObj.tunnelScanValidationResult.epcOverage'
    },
    3: {
      key: 'languageObj.tunnelScanValidationResult.epcShortage'
    },
    4: {
      key: 'languageObj.tunnelScanValidationResult.upcMismatched'
    },
    5: {
      key: 'languageObj.tunnelScanValidationResult.Unexpected'
    },
    6: {
      key: 'languageObj.tunnelScanValidationResult.manualConfirm'
    },
    7: {
      key: 'languageObj.tunnelScanValidationResult.newCarton'
    }
  }
  const parseToArray = val => {
    if (Array.isArray(val)) {
      return val.map(v => (v === null || v === undefined ? '' : String(v).trim())).filter(v => v !== '')
    }
    if (val === null || val === undefined || val === '') return []
    return String(val)
      .split(/[,\n;，\s]+/)
      .map(v => v.trim())
      .filter(v => v !== '')
  }
  const language = useSelector(state => state.commonStore.language)

  const renderMismatchedSku = value => {
    if (value === null || value === undefined || value === '') return value
    return String(value)
      .split(',')
      .map(item => {
        const trimmed = item.trim()
        return trimmed === UNKNOWN_SKU_CODE
          ? formatMessageNew('languageObj.tunnelScanValidationResult.unknownSku')
          : trimmed
      })
      .join(',')
  }

  let formRef = useRef(null)

  // 验证函数，确保 cartonNumber/asnDn/grDate 三选一
  const validateSearchParams = info => {
    const carton = (info.cartonNumber || '').toString().trim()
    const asnDn = (info.asnDn || '').toString().trim()
    const gr = info.grDate

    const hasCarton = carton !== ''
    const hasAsnDn = asnDn !== ''
    const hasGr = Array.isArray(gr) ? gr.length > 0 && (gr[0] || gr[1]) : !!gr

    if (!hasCarton && !hasAsnDn && !hasGr) {
      return {
        ok: false,
        message: formatMessageNew('languageObj.tunnelScanValidationResult.opitionError')
      }
    }

    return { ok: true }
  }

  const searchListInit = [
    {
      type: 'select',
      label: 'languageObj.tunnelScanValidationResult.validationScanResult',
      key: 'validationResult',
      selectList: REWORK_CHECK_RESULT_STATUS,
      mode: 'multiple',
      allowClear: true,
      maxTagCount: 1,
      initialValues: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.tunnelScanValidationResult.plants',
      key: 'plant',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'languageObj.tunnelScanValidationResult.cartonNumber',
      key: 'cartonNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'languageObj.tunnelScanValidationResult.asnDn',
      key: 'asnDn',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRange',
      label: 'languageObj.tunnelScanValidationResult.grDate',
      key: 'grDate',
      format: dateFormatYearMonthDay,
      initialValues: [startMonth, endMonth],
      disabledDate: current => {
        if (!current) return false
        const c = dayjs(current).startOf('day')
        const todayEnd = dayjs().endOf('day')
        return c.isAfter(todayEnd)
      },
      allowClear: true,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.tunnelScanValidationResult.cartonPe',
      key: 'cartonPeList',
      selectList: CARTON_PE,
      mode: 'multiple',
      allowClear: true,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.tunnelScanValidationResult.isRelabel',
      key: 'isRelabel',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: CHECK_LIST,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.tunnelScanValidationResult.isMislabel',
      key: 'isMislabel',
      allowClear: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: CHECK_LIST,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    }
  ]

  const [searchList, setSearchList] = useState(searchListInit)

  const tableColumns = [
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.asnDn'),
      dataIndex: 'asnDn',
      width: 150,
      fixed: 'left'
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.cartonNumber'),
      dataIndex: 'cartonNumber',
      width: 160,
      fixed: 'left'
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.skuNumber'),
      dataIndex: 'skuNumber',
      width: 120
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.nfcSku'),
      dataIndex: 'nfcSku',
      width: 120,
      filters: [
        { text: 'Y', value: 'Y' },
        { text: 'N', value: 'N' }
      ],
      filteredValue: Array.isArray(nfcSkuFilter) && nfcSkuFilter.length ? nfcSkuFilter : null,
      filterMultiple: true
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.specialSku'),
      dataIndex: 'specialSku',
      width: 120,
      filters: [
        { text: 'Y', value: 'Y' },
        { text: 'N', value: 'N' }
      ],
      filteredValue: Array.isArray(specialSkuFilter) && specialSkuFilter.length ? specialSkuFilter : null,
      filterMultiple: true
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.asnDnQty'),
      dataIndex: 'asnDnQty',
      width: 80
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.scanQty'),
      dataIndex: 'scanQty',
      width: 80
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.deltaQty'),
      width: 80,
      dataIndex: 'deltaQty',
      render: (val, record) => {
        const toNum = v => {
          if (v === null || v === undefined || v === '') return 0
          const n = Number(v)
          return Number.isNaN(n) ? 0 : n
        }
        const scan = toNum(record && record.scanQty)
        const asn = toNum(record && record.asnDnQty)
        const delta = scan - asn
        return <span>{delta}</span>
      }
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.latestValidationScanResult'),
      dataIndex: 'latestValidationScanResult',
      width: 220,
      render: val => {
        const actualVal = val === null ? 7 : val
        const cfg =
          actualVal !== undefined && actualVal !== null && bingResultConfig[actualVal]
            ? bingResultConfig[actualVal]
            : null
        const style = (cfg && cfg.style) || {}
        const text =
          cfg && cfg.key
            ? formatMessageNew(cfg.key)
            : actualVal !== undefined && actualVal !== null
            ? String(actualVal)
            : '--'
        return <span style={style}>{text}</span>
      }
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.grDate'),
      dataIndex: 'grGiDate',
      width: 150
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.plants'),
      dataIndex: 'plant',
      width: 80
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.productName'),
      dataIndex: 'productName',
      width: 200
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.cartonPe'),
      dataIndex: 'cartonPe',
      width: 80
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.misMatchedSku'),
      dataIndex: 'misMatchedSku',
      render: renderMismatchedSku,
      width: 120
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.misMatchedQty'),
      dataIndex: 'mismatchedQty',
      width: 120
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.isRelabel'),
      dataIndex: 'isRelabel',
      width: 80
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.isMislabel'),
      dataIndex: 'isMislabel',
      width: 100
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.lastScannedDevice'),
      dataIndex: 'deviceCode',
      width: 180
    },
    {
      title: () => formatMessageNew('languageObj.tunnelScanValidationResult.lastScanTime'),
      dataIndex: 'lastScanTime',
      width: 150
    }
  ]

  useEffect(() => {
    mounting.current && searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  useEffect(() => {
    findPlantModulesFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const findPlantModulesFun = () => {
    getOutboundScanDropList().then(res => {
      searchListInit.forEach(itemFirst => {
        if (itemFirst.key === 'plant') {
          const arr = (res.resultData.plants || ['1025', '1027']).filter(item => item === '1025' || item === '1027')
          itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 3))
        }
      })
      setSearchList([...searchListInit])
    })
  }

  const downLoadFun = () => {
    // 在下载前校验参数
    const info = (formRef.current && formRef.current.getSearchValue && formRef.current.getSearchValue()) || {}
    const valid = validateSearchParams(info)
    if (!valid.ok) {
      modalError({ content: valid.message })
      return
    }

    const params = {
      ...getParams(),
      isChinese: language === 'zh_CN' ? true : false,
      size: 999999,
      pageNo: 1,
      total: 0
    }
    getTunnelValidationResultDownload(params)
      .then(res => {
        downLoadFileBlob(res)
      })
      .catch(err => {
        modalError({
          content: err.errorMessage
        })
      })
  }

  const searchDataBtn = () => {
    // 在查询前校验参数
    const info = (formRef.current && formRef.current.getSearchValue && formRef.current.getSearchValue()) || {}
    const valid = validateSearchParams(info)
    if (!valid.ok) {
      modalError({ content: valid.message })
      return
    }

    mounting.current = true
    // 触发服务端分页查询，重置到第一页
    setPagination(prev => ({ ...prev, currentPage: 1 }))
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    mounting.current = true
    formRef && formRef.current.clearForm()
    // 清空后也清除数据和页码
    setSummaryTableList([])
    setDetailTableList([])
    // 同时清空列过滤条件
    setNfcSkuFilter([])
    setSpecialSkuFilter([])
    setPagination(prev => ({ ...prev, currentPage: 1 }))
    setQueryFlag(!queryFlag)
  }

  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const { grDate } = info
    const vr = info.validationResult
    const validationResult = Array.isArray(vr)
      ? vr.length === 0
        ? [1, 2, 3, 4, 5, 6, 7]
        : vr
      : vr === null || vr === undefined || vr === ''
      ? []
      : [vr]
    const params = {
      ...info,
      businessType: IB_BUSINESS_TYPE,
      grDateStart: formatStartTime(grDate),
      grDateEnd: formatEndTime(grDate),
      cartonNumber: parseToArray(info.cartonNumber),
      asnDn: parseToArray(info.asnDn),
      validationResult,
      // Y/N 多选值传给后端
      nfcSku: Array.isArray(nfcSkuFilter) ? nfcSkuFilter : [],
      specialSku: Array.isArray(specialSkuFilter) ? specialSkuFilter : []
    }

    // 如果 plant 未选择，则使用 searchList 中 plant 的所有选项值作为查询
    const plantItem = (searchList || []).find(item => item.key === 'plant')
    const allPlants = plantItem && Array.isArray(plantItem.selectList) ? plantItem.selectList.map(v => v.value) : []

    params.plant = info.plant && Array.isArray(info.plant) && info.plant.length > 0 ? info.plant : allPlants

    delete params.grDate
    return params
  }
  const searchDataFun = () => {
    const params = {
      ...getParams(),
      size: pagination.pageSize,
      pageNo: pagination.currentPage,
      total: pagination.total
    }
    // 只保留summary查询
    getTunnelValidationResultData(params)
      .then(res => {
        if (res && res.resultData) {
          const dt = res.resultData
          // 保存完整数据，前端分页展示
          setSummaryTableList(dt.summary)
          setDetailTableList(dt.detail.records)
          const pg = {
            ...pagination,
            total: dt.detail.total
          }
          setPagination(pg)
        }
      })
      .catch(err => {
        modalError({
          content: err.errorMessage
        })
      })
  }

  // 处理表格分页和列过滤变化（Antd Table 会传 pagination、filters、sorter）
  const handleTableChange = (pagina, filters) => {
    // 同步列过滤 state（nfcSku / specialSku）
    if (filters) {
      if (Object.prototype.hasOwnProperty.call(filters, 'nfcSku')) {
        const v = filters.nfcSku || []
        setNfcSkuFilter(Array.isArray(v) ? v : [])
      }
      if (Object.prototype.hasOwnProperty.call(filters, 'specialSku')) {
        const v = filters.specialSku || []
        setSpecialSkuFilter(Array.isArray(v) ? v : [])
      }
    }

    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(flag => !flag)
  }

  function buildSummary(data = []) {
    if (!Array.isArray(data)) return { rows: [], totals: { mixedCartonCount: 0, cartonCount: 0 } }

    // 文本 key -> 前端期望的 code 映射
    const KEY_NAME_TO_CODE = {
      accurate: '1',
      upcExceed: '2',
      upcMissed: '3',
      upcMissMatched: '4',
      Unexpected: '5',
      manualConfirm: '6',
      noScan: '7'
    }

    const summaryRows = []
    let responseTotals = null

    data.forEach(item => {
      const rawKey = Object.keys(item)[0] || 'unknown'
      const val = item[rawKey] || {}

      if (String(rawKey).toLowerCase() === 'total') {
        responseTotals = {
          mixedCartonCount: Number(val.mixedCartonCount || 0),
          cartonCount: Number(val.cartonCount || 0)
        }
        return
      }

      // 兼容：如果 rawKey 本身是数字字符串则直接使用，
      // 否则按映射表尝试转换（同时尝试小写匹配以提高容错）
      let key = String(rawKey)
      if (!/^[0-9]+$/.test(key)) {
        const lower = key.toLowerCase()
        key = KEY_NAME_TO_CODE[key] || KEY_NAME_TO_CODE[lower] || key
      }

      summaryRows.push({
        key: String(key),
        mixedCartonCount: Number(val.mixedCartonCount || 0),
        cartonCount: Number(val.cartonCount || 0)
      })
    })

    const calculatedTotals = summaryRows.reduce(
      (acc, r) => {
        acc.mixedCartonCount += r.mixedCartonCount
        acc.cartonCount += r.cartonCount
        return acc
      },
      { mixedCartonCount: 0, cartonCount: 0 }
    )

    return { rows: summaryRows, totals: responseTotals || calculatedTotals }
  }

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>

        <div
          className="summary-table"
          style={{ display: 'flex', justifyContent: 'center', marginTop: 20, marginBottom: 20 }}
        >
          <table
            style={{
              borderCollapse: 'collapse',
              width: '80%',
              fontSize: 16,
              tableLayout: 'fixed' // 固定布局，确保 th 的 width 生效
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: '1px solid #ddd',
                    padding: 10,
                    textAlign: 'center',
                    background: '#fafafa',
                    fontSize: 16,
                    width: 120
                  }}
                >
                  {formatMessageNew('languageObj.tunnelScanValidationResult.validationResult')}
                </th>
                <th
                  style={{
                    border: '1px solid #ddd',
                    padding: 10,
                    textAlign: 'center',
                    background: '#fafafa',
                    fontSize: 16,
                    width: 100
                  }}
                >
                  {formatMessageNew('languageObj.tunnelScanValidationResult.accurate')}
                </th>
                <th
                  style={{
                    border: '1px solid #ddd',
                    padding: 10,
                    textAlign: 'center',
                    background: '#fafafa',
                    fontSize: 16,
                    width: 100
                  }}
                >
                  {formatMessageNew('languageObj.tunnelScanValidationResult.epcShortage')}
                </th>
                <th
                  style={{
                    border: '1px solid #ddd',
                    padding: 10,
                    textAlign: 'center',
                    background: '#fafafa',
                    fontSize: 16,
                    width: 100
                  }}
                >
                  {formatMessageNew('languageObj.tunnelScanValidationResult.epcOverage')}
                </th>
                <th
                  style={{
                    border: '1px solid #ddd',
                    padding: 10,
                    textAlign: 'center',
                    background: '#fafafa',
                    fontSize: 16,
                    width: 100
                  }}
                >
                  {formatMessageNew('languageObj.tunnelScanValidationResult.upcMismatched')}
                </th>
                <th
                  style={{
                    border: '1px solid #ddd',
                    padding: 10,
                    textAlign: 'center',
                    background: '#fafafa',
                    fontSize: 16,
                    width: 100
                  }}
                >
                  {formatMessageNew('languageObj.tunnelScanValidationResult.newCarton')}
                </th>
                <th
                  style={{
                    border: '1px solid #ddd',
                    padding: 10,
                    textAlign: 'center',
                    background: '#fafafa',
                    fontSize: 16,
                    width: 100
                  }}
                >
                  {formatMessageNew('languageObj.tunnelScanValidationResult.manualConfirm')}
                </th>
                <th
                  style={{
                    border: '1px solid #ddd',
                    padding: 10,
                    textAlign: 'center',
                    background: '#fafafa',
                    fontSize: 16,
                    width: 100
                  }}
                >
                  {formatMessageNew('languageObj.tunnelScanValidationResult.total')}
                </th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                const rowMap = (rows || []).reduce((acc, r) => {
                  acc[String(r.key)] = r
                  return acc
                }, {})
                const typeOrder = ['1', '3', '2', '4', '7', '6'] // 固定行顺序：准确、UPC少、UPC多、UPC不匹配、新箱号、人工确认
                const getVal = (key, field) => {
                  const r = rowMap[key]
                  return r && r[field] != null ? r[field] : 0
                }
                return (
                  <>
                    <tr>
                      <td
                        style={{
                          border: '1px solid #eee',
                          padding: 10,
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {formatMessageNew('languageObj.tunnelScanValidationResult.ttlCartonQty')}
                      </td>
                      {typeOrder.map(k => (
                        <td
                          key={k}
                          style={{
                            border: '1px solid #eee',
                            padding: 10,
                            textAlign: 'center',
                            fontSize: 16,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {getVal(k, 'cartonCount')}
                        </td>
                      ))}
                      <td
                        style={{
                          border: '1px solid #eee',
                          padding: 10,
                          textAlign: 'center',
                          fontSize: 16,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          fontWeight: 600
                        }}
                      >
                        {totals.cartonCount}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          border: '1px solid #eee',
                          padding: 10,
                          textAlign: 'center',
                          fontWeight: 600,
                          fontSize: 16,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {formatMessageNew('languageObj.tunnelScanValidationResult.mislabelingCartonQty')}
                      </td>
                      {typeOrder.map(k => (
                        <td
                          key={k + '_mixed'}
                          style={{
                            border: '1px solid #eee',
                            padding: 10,
                            textAlign: 'center',
                            fontSize: 16,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {getVal(k, 'mixedCartonCount')}
                        </td>
                      ))}
                      <td
                        style={{
                          border: '1px solid #eee',
                          padding: 10,
                          textAlign: 'center',
                          fontSize: 16,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          fontWeight: 600
                        }}
                      >
                        {totals.mixedCartonCount}
                      </td>
                    </tr>
                  </>
                )
              })()}
            </tbody>
          </table>
        </div>

        <div className="content-container">
          <ActionBar onDownload={downLoadFun} style={{ alignItems: 'end' }} />
          <AntdTable
            dataSource={detailTableList}
            columns={tableColumns}
            columnsKey="tunnelScanValidationResultReportColumns"
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </Card>
    </div>
  )
}
export default TunnelScanValidationResult
